module.exports = __webpack_public_path__ + "static/media/icon-copy.9dc9a9a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-copy.svg
// module id = 1255
// module chunks = 19